import React from 'react';
import type { WeightUnit } from '../data/types';
import './SettingsPage.css';

interface SettingsPageProps {
    isOpen: boolean;
    onClose: () => void;
    weightUnit: WeightUnit;
    onWeightUnitChange: (unit: WeightUnit) => void;
}

export function SettingsPage({ isOpen, onClose, weightUnit, onWeightUnitChange }: SettingsPageProps) {
    if (!isOpen) return null;

    return (
        <div className="settings-page active">
            <div className="settings-header">
                <button className="back-btn" onClick={onClose}>←</button>
                <h2>Settings</h2>
            </div>

            <div className="settings-content">
                <div className="setting-item">
                    <div className="setting-header">
                        <div className="setting-title">Weight Units</div>
                    </div>
                    <div className="setting-description">
                        Choose how you want to track and display weights
                    </div>
                    <div className="unit-toggle">
                        <div
                            className={`unit-option ${weightUnit === 'grams' ? 'selected' : ''}`}
                            onClick={() => onWeightUnitChange('grams')}
                        >
                            Grams (g)
                        </div>
                        <div
                            className={`unit-option ${weightUnit === 'ounces' ? 'selected' : ''}`}
                            onClick={() => onWeightUnitChange('ounces')}
                        >
                            Ounces (oz)
                        </div>
                    </div>
                </div>

                <div className="setting-item">
                    <div className="setting-header">
                        <div className="setting-title">About Foster Pal</div>
                    </div>
                    <div className="setting-description">
                        Version 0.1.0 (MVP)<br />
                        Made with ❤️ for foster parents<br />
                        Part of PetRescueHub
                    </div>
                </div>

                <div className="setting-item">
                    <div className="setting-header">
                        <div className="setting-title">Data Storage</div>
                    </div>
                    <div className="setting-description">
                        All your data is stored locally on this device using IndexedDB. Nothing is sent to any server. Your data stays yours.
                    </div>
                </div>
            </div>
        </div>
    );
}